import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { getOrganizatioanApi, getUnitAPI } from "api";
import { withTranslation } from "react-i18next";

class OrganizationCompanyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      organization: {},
      searchName: "",
      // productData: products,
      unitList: [],
    };
  }

  async componentDidMount() {
    let organization = await getOrganizatioanApi();
    if(organization && organization.data){
      this.setState({ organization: organization.data.organizations[0] });
    }
    
    this.getPartyList();
  }
  async getPartyList1(inputValue) {
    console.log(inputValue);
    const data = await getUnitAPI({ isInternal: null, name: inputValue });
    if (data && data.data && Array.isArray(data.data.factories)) {
      this.setState({
        unitList: data.data.factories,
      });
    }
    return [{label: "All", value: ""}, ...this.state.unitList.map(x => {
      return { label: x.name, value: x.id };
    })]
  }
  async getPartyList(inputValue) {
    console.log(inputValue);
    const data = await getUnitAPI({ isInternal: null, name: inputValue });
    if (data && data.data && Array.isArray(data.data.factories)) {
      this.setState({
        unitList: data.data.factories,
      });
    }
  }

  render() {
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList1(inputValue));
        }, 0);
      });
    const columns = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "factoryname",
        text: `${this.props.t("Factory(Unit) Name")}`,
        formatter: (cell, row) => (
          <div className="d-flex flex-row">
            <div className="ps-2 ">
              <p className="fw-bold fs-5 pt-2"> {row.name} </p>
            </div>
          </div>
        ),
      },
      {
        dataField: "factoryType",
        text: `${this.props.t("Factory Type")}`,
        formatter: (cell, row) => {
          return row.factoryType === 1 ? (
            <div>Internal</div>
          ) : (
            <div>External</div>
          );
        },
      },
      {
        dataField: "cvdRate",
        text: `${this.props.t("CVD Rate")}`,
        formatter: (cell, row) => {
          return row.isInternal === true ? (
            <div>{this.state.organization.cvdRate}</div>
          ) : (
            cell
          );
        },
      },
      {
        dataField: "lphtRate",
        text: `${this.props.t("LPHT Rate")}`,
        formatter: (cell, row) => {
          return row.isInternal === true ? (
            <div>{this.state.organization.lphtRate}</div>
          ) : (
            cell
          );
        },
      },
      {
        dataField: "realRate",
        text: `${this.props.t("REAL Rate")}`,
        formatter: (cell, row) => {
          return row.isInternal === true ? (
            <div>{this.state.organization.realRate}</div>
          ) : (
            cell
          );
        },
      },
      {
        dataField: "jiramRate",
        text: `${this.props.t("JIRAM Rate")}`,
        formatter: (cell, row) => {
          return row.isInternal === true ? (
            <div>{this.state.organization.jiramRate}</div>
          ) : (
            cell
          );
        },
      },
      {
        dataField: "tdsRate",
        text: `${this.props.t("TDS Rate")}`,
        formatter: (cell, row) => {
          return row.isInternal === true ? (
            <div>{this.state.organization.tdsRate}</div>
          ) : (
            cell
          );
        },
      },
      {
        dataField: "viewdetails",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <div className="btn-group">
            <Link
              to={{
                pathname: "/add-unit",
                query: { isEdit: true, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded">
                <img src="images/dashboard-images/edit.svg" />
              </button>
            </Link>

            <Link
              to={{
                pathname: "/add-unit",
                query: { isView: true, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          </div>
        ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getPartyList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getPartyList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "manage organisation";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.state.unitList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.unitList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("Factory List")}
                    </h3>
                    <Row>
                      <Col md="6" sm="12">
                        <div className="pt-4">
                          <p className="d-inline pe-3 fs-5">
                            {this.props.t("Show")}
                          </p>
                          <div className="d-inline">
                            <SizePerPageDropdownStandalone
                              className=""
                              {...paginationProps}
                            />
                          </div>

                          <p className="d-inline ps-3 fs-5">
                            {this.props.t("entries")}
                          </p>
                        </div>
                      </Col>
                      <Col
                        xxl={{ offset: "3", size: "3" }}
                        xl={{ offset: "2", size: "4" }}
                        md={{ offset: "0", size: "6" }}
                        sm={{ offset: "0", size: "12" }}
                        className="text-start text-lg-end pt-4 pt-lg-0"
                      >
                        <div className="d-flex justify-content-end">
                          <div className="">
                            <label
                              htmlFor="search"
                              className="pt-2 fs-5 pe-1 text-end pe-lg-3 d-inline"
                            >
                              {this.props.t("Search")}
                            </label>
                          </div>
                          <AsyncSelect
                            onChange={e =>{
                              if (e.value == "") {
                                this.getPartyList(null);
                              } else {

                                this.getPartyList(e.label);
                              }
                            } }
                            
                            loadOptions={promiseOptions}
                            defaultOptions={[{label: "All", value: ""}, ...this.state.unitList.map(x => {
                              return { vlaue: x.id, label: x.name };
                            })]}
                            className="border-gray"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <CardTitle className="h4">
                              {this.props.t("Factory List")}
                            </CardTitle>

                            <React.Fragment>
                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex"></Col>
                              </Row>
                              <Row className="mb-2"></Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      remote={true}
                                      keyField={"id"}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      columns={columns}
                                      onTableChange={() => false}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Col className="inner-custom-pagination mt-4">
                                <div className="text-md-right ms-auto">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </React.Fragment>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(OrganizationCompanyList);
